import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 23 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M14.716 14.48a1.19 1.19 0 00-.852.354l-.466.45a.418.418 0 01-.45.097.402.402 0 01-.242-.37V9.253a1.207 1.207 0 10-2.411 0v5.774a.404.404 0 01-.241.37.418.418 0 01-.45-.112l-.467-.467a1.206 1.206 0 00-1.704 1.705l3.216 3.217a1.206 1.206 0 001.704 0l3.215-3.217a1.207 1.207 0 000-1.705 1.19 1.19 0 00-.852-.338z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ a.createElement(
    "path",
    {
      d: "M19.264 6.73a.37.37 0 01-.24-.29 7.303 7.303 0 00-6.32-5.846 7.297 7.297 0 00-7.492 4.238.386.386 0 01-.273.225A6.27 6.27 0 00.252 10.96a6.274 6.274 0 004.365 6.144.402.402 0 00.483-.193c.165-.314.376-.601.627-.852.284-.23.604-.41.948-.53a.267.267 0 00-.193-.5 3.858 3.858 0 01-3.856-3.683 3.861 3.861 0 013.503-4.02 1.222 1.222 0 001.045-.853 4.954 4.954 0 014.678-3.506 4.822 4.822 0 014.824 4.696 1.239 1.239 0 001.013 1.142 3.103 3.103 0 012.653 3.088 3.217 3.217 0 01-3.104 3.217h-.176a.402.402 0 00-.386.29.418.418 0 00.177.45c.151.09.292.198.418.321.286.284.52.616.691.982a.418.418 0 00.45.225 5.546 5.546 0 004.32-4.97 5.55 5.55 0 00-3.468-5.597v-.08z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
